import React from 'react'
import { graphql } from 'gatsby'
import { Asset } from "../../../../plugins/gatsby-plugin-atollon";

const AboutBanner = ({image}) => {
  return (
    <section className="about-banner">
      <div className="about-banner__inner">
        <div className='about-banner__wrapper'>
          {image && <Asset className="about-banner__bg" asset={image}/>}
        </div>
      </div>
    </section>
  )
}
export default AboutBanner
export const query = graphql`
fragment AboutBannerProps on DatoCmsAboutBanner {
  ... on DatoCmsAboutBanner {
    id
    image {
      ...InternalAssetProps
    }
  }
}
`;